// * format: { label: string, value: string }
// export const GENRE = [
//   {
//     label: 'Pop',
//     value: 'POP',
//   },
//   {
//     label: 'Rock',
//     value: 'ROCK',
//   },
//   {
//     label: 'Hip Hop',
//     value: 'HIP_HOP',
//   },
// ];

// * options:
export const GENRE = [
  // - Afrobeat
  { label: 'Afrobeat', value: 'Afrobeat' },
  // - Afropop
  { label: 'Afropop', value: 'Afropop' },
  // - Alternative
  { label: 'Alternative', value: 'Alternative' },
  // - Big Band
  { label: 'Big Band', value: 'Big Band' },
  // - Big Room
  { label: 'Big Room', value: 'Big Room' },
  // - Blues
  { label: 'Blues', value: 'Blues' },
  // - Breaks
  { label: 'Breaks', value: 'Breaks' },
  // - Chill Out
  { label: 'Chill Out', value: 'Chill Out' },
  // - Children's Music
  { label: "Children's Music", value: "Children's Music" },
  // - Christian/Gospel
  { label: 'Christian / Gospel', value: 'Christian / Gospel' },
  // - Classical
  { label: 'Classical', value: 'Classical' },
  // - Comedy
  { label: 'Comedy', value: 'Comedy' },
  // - Country
  { label: 'Country', value: 'Country' },
  // - Dance
  { label: 'Dance', value: 'Dance' },
  // - Deep House
  { label: 'Deep House', value: 'Deep House' },
  // - Drum & Bass
  { label: 'Drum & Bass', value: 'Drum & Bass' },
  // - Dubstep
  { label: 'Dubstep', value: 'Dubstep' },
  // - Electro House
  { label: 'Electro House', value: 'Electro House' },
  // - Electronic
  { label: 'Electronic', value: 'Electronic' },
  // - Electronica / Downtempo
  { label: 'Electronica / Downtempo', value: 'Electronica / Downtempo' },
  // - Fitness & Workout
  { label: 'Fitness & Workout', value: 'Fitness & Workout' },
  // - Folk
  { label: 'Folk', value: 'Folk' },
  // - French Pop
  { label: 'French Pop', value: 'French Pop' },
  // - Funk / Soul / Disco
  { label: 'Funk / Soul / Disco', value: 'Funk / Soul / Disco' },
  // - German Folk
  { label: 'German Folk', value: 'German Folk' },
  // - German Pop
  { label: 'German Pop', value: 'German Pop' },
  // - Glitch Hop
  { label: 'Glitch Hop', value: 'Glitch Hop' },
  // - Hard Dance
  { label: 'Hard Dance', value: 'Hard Dance' },
  // - Hardcore / Hard Techno
  { label: 'Hardcore / Hard Techno', value: 'Hardcore / Hard Techno' },
  // - Hip Hop/Rap
  { label: 'Hip Hop/Rap', value: 'Hip Hop/Rap' },
  // - Hip-Hop / R&B
  { label: 'Hip-Hop / R&B', value: 'Hip-Hop / R&B' },
  // - Holiday
  { label: 'Holiday', value: 'Holiday' },
  // - House
  { label: 'House', value: 'House' },
  // - Indie Dance / Nu Disco
  { label: 'Indie Dance / Nu Disco', value: 'Indie Dance / Nu Disco' },
  // - J-Pop
  { label: 'J-Pop', value: 'J-Pop' },
  // - Jazz
  { label: 'Jazz', value: 'Jazz' },
  // - K-Pop
  { label: 'K-Pop', value: 'K-Pop' },
  // - Latin
  { label: 'Latin', value: 'Latin' },
  // - Latin Urban
  { label: 'Latin Urban', value: 'Latin Urban' },
  // - Metal
  { label: 'Metal', value: 'Metal' },
  // - Minimal / Deep Tech
  { label: 'Minimal / Deep Tech', value: 'Minimal / Deep Tech' },
  // - New Age
  { label: 'New Age', value: 'New Age' },
  // - Pop
  { label: 'Pop', value: 'Pop' },
  // - Progressive House
  { label: 'Progressive House', value: 'Progressive House' },
  // - Psy-Trance
  { label: 'Psy-Trance', value: 'Psy-Trance' },
  // - Punk
  { label: 'Punk', value: 'Punk' },
  // - R&B/Soul
  { label: 'R&B/Soul', value: 'R&B/Soul' },
  // - Reggae
  { label: 'Reggae', value: 'Reggae' },
  // - Reggae / Dancehall / Dub
  { label: 'Reggae / Dancehall / Dub', value: 'Reggae / Dancehall / Dub' },
  // - Rock
  { label: 'Rock', value: 'Rock' },
  // - Singer/Songwriter
  { label: 'Singer/Songwriter', value: 'Singer/Songwriter' },
  // - Soundtrack
  { label: 'Soundtrack', value: 'Soundtrack' },
  // - Spoken Word
  { label: 'Spoken Word', value: 'Spoken Word' },
  // - Tech House
  { label: 'Tech House', value: 'Tech House' },
  // - Techno
  { label: 'Techno', value: 'Techno' },
  // - Trance
  { label: 'Trance', value: 'Trance' },
  // - Vocal
  { label: 'Vocal', value: 'Vocal' },
  // - World
  { label: 'World', value: 'World' },
];
